<template>
  <div class="component">
    <div class="main-title">
      <div class="square"></div>
      <div class="title-content">教育概览</div>
    </div>
    <div class="main-content">
      <portrait-labels :labelList="componentData.eduOverview"></portrait-labels>
      <div class="sub" v-if="componentData.eduExperience!=null&&componentData.eduExperience.length>0">
        <div class="sub-title">
          教育经历
        </div>
        <div class="sub-content">
          <el-timeline>
            <el-timeline-item
                v-for="item in componentData.eduExperience"
            >
              <div class="timeline-content">
                <div class="timeline-title">{{ item.timeAxis }}</div>
                <div class="timeline-detail">
                  <div class="slotInfos" v-if="trimArray(item.slotInfo) && trimArray(item.slotInfo).length">
                    <div class="slotInfo" v-for="(slotInfo,slotInfoIndex) in  trimArray(item.slotInfo)">
                      {{ slotInfo }}
                      <el-divider v-if="slotInfoIndex !== (item.slotInfo.length-1)"
                                  direction="vertical"></el-divider>
                    </div>

                  </div>
                  <portrait-labels :labelList="item.slotLabel"></portrait-labels>
                </div>
              </div>
            </el-timeline-item>
            <div class="timeAxis">
              <el-timeline-item
              ></el-timeline-item>
            </div>
          </el-timeline>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TabEducation",
  props: {
    componentData: [Object, Array]
  },
  data() {
    return {}
  },
  mounted() {
    console.log(this.componentData)
  },
  methods: {
    trimArray(array) {
      let result = []
      this.$emit("trimArray", array, val => {
        result = val
      })
      return result
    }
  },
}
</script>

<style lang="less">

</style>
